import { render, staticRenderFns } from "./datos-punto-suministro.vue?vue&type=template&id=35dc1cc0&"
import script from "./datos-punto-suministro.vue?vue&type=script&lang=js&"
export * from "./datos-punto-suministro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports